// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/5af9a5c4/" + chunkId + "." + __webpack_require__.h() + ".v5af9a5c4.js";
};